import { useEffect, useState } from 'react';
import { ChildBase } from '@unicorn/sdui';

export const useSduiValidation = ({
  sduiData,
  sduiReadonly,
}: {
  sduiData: ChildBase[];
  sduiReadonly: boolean;
}) => {
  const [valid, setValid] = useState(false);

  const visibleInputs = sduiData.filter(
    ({ spec, data }) => spec.startsWith('input-') && data.visible !== false
  );
  const notValidInputs = visibleInputs.filter(({ data }) => data.valid === false);
  const mainLoaderVisible = !!sduiData.find(({ token }) => token === 'main-loader')?.data
    .visible;

  const resolveValidation = () => {
    if (visibleInputs.length <= 1) return;

    if (mainLoaderVisible) {
      if (valid) setValid(false);

      return;
    }

    setValid(!notValidInputs.length);
  };

  useEffect(() => {
    resolveValidation();
  }, [notValidInputs.length, mainLoaderVisible, sduiReadonly]);

  return valid;
};
